import { gql } from '@apollo/client'

export const GET_DATA_MIGRATIONS = gql`
  query GetDataMigrations {
    dataMigrations {
      dataMigrationId
      migrationId
      provider
      phase
      sourceUrl
      sourceZipPasswordSet
      sourceFilename
      batchSize
      parallel
      progress
      lastHeartbeatAt
      rawFileCount
      rawTotalBytes
      transformedFileCount
      totalApplicants
      entriesCreatedCount
      entriesVerifiedAt
      errorMessage
      createdAt
      updatedAt
      uploadCompletedAt
      transformationCompletedAt
      completedAt
      failedAt
      initiatedBy {
        # employeeId is required: Apollo's cache is configured with
        # Employee: { keyFields: ['employeeId'] }, and omitting it makes the
        # cache write throw, so the query never resolves.
        employeeId
        firstName
        lastName
      }
      phaseLogs {
        dataMigrationPhaseLogId
        fromPhase
        toPhase
        detail
        createdAt
      }
    }
  }
`

export const CREATE_DATA_MIGRATION = gql`
  mutation CreateDataMigration($input: CreateDataMigrationInput!) {
    createDataMigration(input: $input) {
      dataMigrationId
      migrationId
      provider
      phase
      createdAt
    }
  }
`

export const CREATE_DATA_MIGRATION_UPLOAD_URL = gql`
  mutation CreateDataMigrationUploadUrl(
    $dataMigrationId: String!
    $filename: String!
  ) {
    createDataMigrationUploadUrl(
      dataMigrationId: $dataMigrationId
      filename: $filename
    ) {
      uploadUrl
    }
  }
`

export const CANCEL_DATA_MIGRATION = gql`
  mutation CancelDataMigration($dataMigrationId: String!) {
    cancelDataMigration(dataMigrationId: $dataMigrationId) {
      dataMigrationId
      phase
      errorMessage
      updatedAt
      failedAt
      completedAt
    }
  }
`

export const CONFIRM_DATA_MIGRATION_UPLOAD = gql`
  mutation ConfirmDataMigrationUpload($dataMigrationId: String!) {
    confirmDataMigrationUpload(dataMigrationId: $dataMigrationId) {
      dataMigrationId
      phase
      sourceFilename
      uploadCompletedAt
    }
  }
`
